import { render } from "./BookingExpiredDefault.vue?vue&type=template&id=46352bd4"
import script from "./BookingExpiredDefault.vue?vue&type=script&lang=js"
export * from "./BookingExpiredDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__